import featuresAndBugsTour from "./features-bugs";
import homepageTour from "./homepage";

const driver_tour = {
	close: "Sind Sie sicher, dass Sie die Tour beenden wollen?",
	done: "Fertig",
	features_and_bugs_tour: featuresAndBugsTour,
	homepage_tour: homepageTour,
	next: "Nächster",
	previous: "Vorheriger",
	title: "Driver Tour",
};
export default driver_tour;
